import { Icon, IconProps } from '@chakra-ui/react'

export default function BarChartCircleAverageIcon(props: IconProps) {
  return (
    <Icon
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color={'#077FDE'}
      {...props}
    >
      <path
        d="M21.0036 12.0003C21.0036 16.973 16.9725 21.0041 11.9998 21.0041C7.02721 21.0041 2.99609 16.973 2.99609 12.0003C2.99609 7.0277 7.02721 2.99658 11.9998 2.99658"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.25 9.99951H15.751C16.0273 9.99951 16.2513 10.2235 16.2513 10.4997V15.5018C16.2513 15.7781 16.0273 16.002 15.751 16.002H13.25"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.2493 16.0017H7.74826C7.472 16.0017 7.24805 15.7777 7.24805 15.5015V12.5002C7.24805 12.224 7.472 12 7.74826 12H10.2493"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.2493 16.0018H10.248V7.49826C10.248 7.222 10.472 6.99805 10.7483 6.99805H12.7491C13.0253 6.99805 13.2493 7.222 13.2493 7.49826V16.0018Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  )
}
